var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRizhaofenxi(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 34631331",
    x: 1,
    y: 1.90625,
    width: 15,
    height: 12.1875,
    fill: "white",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 663",
    d: "M0.9375 14L5.0625 10.1875H10.4375L16.0625 5.9375",
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 50",
    x1: 4.4375,
    y1: 10.7812,
    x2: 4.4375,
    y2: 13.875,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 51",
    x1: 7.45312,
    y1: 9.75,
    x2: 7.45312,
    y2: 13.875,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 52",
    x1: 10.2344,
    y1: 9.75,
    x2: 10.2344,
    y2: 13.875,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 53",
    x1: 13.1562,
    y1: 8.21875,
    x2: 13.1562,
    y2: 13.875,
    stroke: "black"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 91",
    cx: 4.21875,
    cy: 4.65625,
    r: 1.3,
    fill: "#FFD076",
    stroke: "black",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 664",
    d: "M2.5 8.96875L3.84375 7.875H9.71875L12.6875 5.34375",
    stroke: "#2F88FF",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle 34631332",
    d: "M12.9062 6.75L12.9062 4.9375L11.0937 4.9375",
    stroke: "#2F88FF",
    strokeWidth: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRizhaofenxi);
export default __webpack_public_path__ + "static/media/rizhaofenxi.d9da037b69b1673fde83c9db39ef9cdd.svg";
export { ForwardRef as ReactComponent };